<script setup lang="ts">
import type { PropertyId } from "~/classes/entity"

import { propertyIcon, propertyName } from "~/classes/entity"

const props = defineProps({
  propertyId: null
})
const emit = defineEmits(["remove"])
const descending = defineModel<boolean>("descending")

const name = computed(() => propertyName(props.propertyId as PropertyId))
const icon = computed(() => propertyIcon(props.propertyId as PropertyId))

const onSwitchSortDirection = () => {
  if (descending.value)
    descending.value = false
  else
    descending.value = true
}

const onRemoveSort = () => {
  emit("remove")
}
</script>

<template>
  <div class="sort-picker-container">
    <div class="sort-picker-description">
      <icon-property :type="icon" size="2xs" />
      <div class="name">
        {{ name }}
      </div>
    </div>
    <div
      class="sort-picker-button"
      @click="onSwitchSortDirection()"
    >
      <icon-action v-if="descending" type="arrow-down" />
      <icon-action v-else type="arrow-up" />
    </div>
    <div class="sort-picker-close" @click="onRemoveSort()">
      <icon-action type="cross" size="2xs" />
    </div>
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.sort-picker-container
  @apply flex flex-none items-center gap-[#{$menu-search-gap-item-facet}] relative
  @apply h-[24px]
  @apply rounded-[#{$menu-br-item}] overflow-hidden
  @apply t-menu-sm

.sort-picker-description
  @apply flex flex-none items-center gap-1
  @apply h-full px-2

.sort-picker-close
  @apply flex flex-none items-center
  @apply h-full px-1

.sort-picker-description
  @apply bg-$global-blue-accent
  @apply text-$global-blue-primary

.sort-picker-close
  @apply bg-$global-blue-accent
  @apply text-$global-blue-primary
  @apply cursor-pointer
  &:hover
    @apply bg-$global-blue-secondary

.sort-picker-button
  @apply flex-none flex items-center gap-[#{$menu-search-gap-item-facet-section}]
  @apply cursor-pointer
  @apply h-full px-0.5 bg-$global-blue-accent
  @apply text-$global-blue-primary
  @apply font-mono uppercase
  &:hover
    @apply bg-$global-blue-secondary

.sort-picker-view
  @apply w-3 h-3 aspect-square rounded-full

.hidden-sort-picker
  @apply w-0 h-0 absolute -bottom-2 left-0
</style>
